const createRequestInterceptor = (httpClient) => {
  let { client } = httpClient

  client.interceptors.request.use(
    (config) => {
      config.headers = {
        'Accept-Language': localStorage.getItem('locale'),
        Authorization: sessionStorage.getItem('mavAuth')
      }
      return config
    },
    (error) => {
      return Promise.reject(error)
    }
  )
}

const createRequestInterceptorBillma = (httpClient) => {
  let { client } = httpClient

  client.interceptors.request.use(
    (config) => {
      let token = sessionStorage.getItem('mavAuth')
      if (token) {
        token = token.replace('Token', 'Bearer')
      }
      config.headers = {
        'Accept-Language': localStorage.getItem('locale'),
        Authorization: token
      }
      return config
    },
    (error) => {
      return Promise.reject(error)
    }
  )
}

const createResponseInterceptor = (httpClient, callback, router) => {
  let { client } = httpClient
  client.interceptors.response.use(
    async (request) => {
      if (request.status === 401) { // refresh token
        const token = callback()
        if (token) {
          sessionStorage.setItem('mavAuth', `Token ${token.token}`)
        }
      } else if (request.status === 403) { // expired token
        if (router) {
          router.replace({ name: 'timedout' })
        }
      }
      return request
    },
    (error) => {
      return Promise.reject(error)
    }
  )
}

export default {
  createRequestInterceptor,
  createResponseInterceptor,
  createRequestInterceptorBillma
}
